import { Modal, message } from "antd";
import React from "react";

import styles from "@/components/PriceSummaryModal/VoucherModal/VoucherModalList.module.css";

interface VoucherModalProps {
  open: boolean;
  onClose: () => void;
  data: any[];
  setSelectedVoucher: (voucher: any) => void;
  selectedVoucher: any;
}

const VoucherModal: React.FC<VoucherModalProps> = ({
  open,
  onClose,
  data,
  setSelectedVoucher,
  selectedVoucher,
}) => {
  const applyVoucher = (voucher: any): void => {
    if (selectedVoucher && selectedVoucher.id === voucher.id) {
      message.warning("This voucher is already applied");
      return;
    }
    setSelectedVoucher(voucher);
    onClose();
  };
  return (
    <Modal title="Voucher List" open={open} onCancel={onClose} footer={null} width={500}>
      <div className={styles.mainContainer}>
        {data.length ? (
          data.map((voucher) => (
            <div key={voucher.id} className={styles.promotionSectionBody}>
              <div className={styles.voucherSection}>
                <div className={styles.promotionSectionHeader}>
                  <div className="flex flex-col">
                    <div className="font-inter text-gray-500">
                      {voucher.voucher_description || ""}
                    </div>
                    <span className="font-inter text-[12px] font-semibold">
                      Code: {voucher.voucher_code || "N/A"}
                    </span>
                    <span className="font-inter text-[12px] font-semibold">
                      Amount: {voucher.voucher_value || "0"}
                    </span>
                  </div>

                  <span
                    className="font-inter text-[12px] font-semibold text-primary cursor-pointer underline"
                    onClick={() => applyVoucher(voucher)}
                  >
                    APPLY
                  </span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className={styles.noPromotionApplied}>No Vouchers Available</div>
        )}
      </div>
    </Modal>
  );
};
export default VoucherModal;
